const findPolycardComponent = (item, type) =>
  item?.polycard
    ? item?.polycard?.components?.find((element) => element.type === type)
    : item?.components?.find((element) => element.type === type);

module.exports = findPolycardComponent;
